import { useEffect, useState } from "react";
import { useRoute } from "wouter";
import { AlertCircle, Box, CheckCircle2, PackageX } from "lucide-react";
import { ProdutoPublico, portalClienteApi } from "../lib/portalClienteApi";

export default function CatalogoPublico() {
  const [, params] = useRoute("/catalogo-publico/:emitente");
  const [produtos, setProdutos] = useState<ProdutoPublico[]>([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");

  useEffect(() => {
    const emitente = params?.emitente;
    if (!emitente) return;
    setCarregando(true);
    setErro("");
    portalClienteApi.catalogoPublico(emitente)
      .then(({ produtos }) => setProdutos(produtos))
      .catch((error) => setErro(error.message || "Não foi possível carregar o catálogo."))
      .finally(() => setCarregando(false));
  }, [params?.emitente]);

  return (
    <main className="min-h-screen bg-slate-50 text-slate-950">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-7xl items-center gap-3 px-5 py-5 sm:px-8">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-orange-500 text-white shadow-sm"><Box className="h-5 w-5" /></div>
          <div><p className="text-xs font-semibold uppercase tracking-[0.18em] text-orange-600">Box</p><h1 className="text-lg font-bold">Catálogo público</h1></div>
        </div>
      </header>

      <section className="mx-auto max-w-7xl px-5 py-8 sm:px-8">
        {carregando && <p className="py-16 text-center text-slate-500">Carregando catálogo...</p>}
        {erro && <div className="flex items-center gap-3 rounded-xl border border-red-200 bg-red-50 p-4 text-red-700"><AlertCircle className="h-5 w-5" />{erro}</div>}
        {!carregando && !erro && produtos.length === 0 && <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-12 text-center text-slate-500">Nenhum produto disponível neste catálogo.</div>}
        {!carregando && !erro && produtos.length > 0 && (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {produtos.map((produto) => (
              <article key={produto.id} className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                <div className="flex aspect-square items-center justify-center bg-slate-100">
                  {produto.fotoPortalUrl ? <img src={produto.fotoPortalUrl} alt={produto.descricao || produto.cod} className="h-full w-full object-cover" /> : null}
                </div>
                <div className="space-y-3 p-4">
                  <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{produto.cod}</p>
                  <h2 className="min-h-12 text-sm font-semibold leading-5 text-slate-900">{produto.descricao || "Sem descrição"}</h2>
                  <div className={`flex items-center gap-2 text-sm font-medium ${produto.disponibilidade === "disponivel" ? "text-emerald-700" : "text-slate-500"}`}>
                    {produto.disponibilidade === "disponivel" ? <CheckCircle2 className="h-4 w-4" /> : <PackageX className="h-4 w-4" />}
                    {produto.disponibilidade === "disponivel" ? "Disponível" : "Indisponível"}
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}
